import {RolandStructuredObject} from "../RolandStructuredObject.js";
import {ZenSampleData} from "../ZenCore/ZenSampleData.js";

/**
 * Incorperates SMPh
 */
export class MCUSD extends RolandStructuredObject {
    constructor(file, data, parent, start, length, description) {
        super(file, data, parent, start, length, description);
        this.ownedLength = this.getUint32(4);
        this.propertiesName = "MCUSD";
    }

    /**
     * Initialise a data view with new object contents
     * @returns {DataView}
     */
    static createNewBuffer() {
        let data = new DataView(new ArrayBuffer(32) );
        data.setInt32(0,0x68504d53,true);
        data.setInt32(4,0x20,true);
        data.setInt32(8,0x2,true);
        return data;
    }

    nestedLoad(lc) {
        let start = this.start+this.ownedLength;
        const originalStart = this.start;
        const sampleCount = this.getUint32(12);

        for(let i=0;i<sampleCount;i++) {
            let length = this.getUint32(start-originalStart+8)+48;
            start = this.createAndLoadChild(lc, ZenSampleData,start, length);
        }
    }

    /**
     *
     * @param child
     */
    addChild( child ) {
        // update sample count
        this.setInt32(12, this.children.length+1);
        this.length += child.length;
        this.children.push( child );
        this.parent.addSingleItemLength(child.length);
    }

    /**
     * // this does not encode the data in the buffer.
     * @return {MCSampleInfo}
     * @param buffer
     * @param filename without extension or path
     */
    addSample(buffer,filename) {
        // calculate length with padding.
        let numChannels = buffer.numberOfChannels;
        let sampleCount = buffer.length;
        let singleChannelSampleDataLength = sampleCount * 2 ; // 16 bit

        let totalBufferSize = Math.ceil(singleChannelSampleDataLength / 512) * 512;
        let paddingLength =  totalBufferSize - singleChannelSampleDataLength;
        if (paddingLength<128) {
            totalBufferSize += 512;
            paddingLength += 512;
        }
        let endPaddingLength = paddingLength-64;
        let totalSampleBufferSize = totalBufferSize * numChannels;
        let objectSize = totalSampleBufferSize + 48;

        let dataBuffer = new ArrayBuffer(objectSize);
        let dv = new DataView(dataBuffer);
        let SMPd = new ZenSampleData(this.file, dv,this,0,objectSize);
        SMPd.setInt32(0,0x64504D53 );                       // "SMPd"
        const a = SMPd.at();
        a.setString("NAME_1", filename);
        a.setUint32("U1", 0x10030 + (numChannels==2 ? 0x20000 : 0));     // 30 is the structure size
        a.setUint32("TOTAL_SAMPLE_DATA_SIZE", totalSampleBufferSize);
        a.setUint32("CHANNEL_SAMPLE_DATA_SIZE", singleChannelSampleDataLength);
        a.setUint8("SAMPLE_NUMBER", this.children.length);
        SMPd.childIndex = this.children.length;
        a.setUint32("SAMPLE_RATE", buffer.sampleRate);
        a.setUint8("STEREO_FLAG", numChannels==2 ? 0x80 : 0 );

        for(let channel=0;channel<numChannels;channel++) {
            let channelData = buffer.getChannelData(channel);
            let pos = 48 + 64 + totalSampleBufferSize/2*channel;
            for(let sample=0;sample<channelData.length;sample++) {
                dv.setInt16(pos, channelData[sample]*32767,true);
                pos+=2;
            }
        }

        let sampleNumber = this.children.length;
        this.addChild(SMPd);
        return sampleNumber;
    }


}